import { render, staticRenderFns } from "./PostalAddress.vue?vue&type=template&id=00a6a763"
import script from "./PostalAddress.vue?vue&type=script&lang=js"
export * from "./PostalAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports